import React from 'react'
import { Box, FormControl, FormControlLabel, Modal, Radio, RadioGroup, Typography } from "@mui/material";
import Button from './Button';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CustomIconButton from './CustomIconButton';

interface DownloadDataProps {
    isDownloadModalOpen: boolean;
    handleDownloadModalClose: () => void;
    selectedFormat: string;
    handleFormatChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    handleDownload: (filterValues?: any) => void;

    modalTitle: string;
    modalDescription: string;
    formatLabel: string;
    formatExcelLabel: string;
    formatCsvLabel: string;
    formatPdfLabel: string;
    cancelButtonText: string;
    downloadButtonText: string;
    downloadLoading?: boolean
}

const DownloadData: React.FC<DownloadDataProps> = ({
    isDownloadModalOpen,
    handleDownloadModalClose,
    selectedFormat,
    handleFormatChange,
    handleDownload,

    modalTitle,
    modalDescription,
    formatLabel,
    formatExcelLabel,
    formatCsvLabel,
    formatPdfLabel,
    cancelButtonText,
    downloadButtonText,
    downloadLoading
}) => {
    return (
        <Modal
            open={isDownloadModalOpen}
            onClose={downloadLoading ? undefined : handleDownloadModalClose}
            aria-labelledby="download-modal-title"
            aria-describedby="download-modal-description"
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '440px',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 4,
                }}
            >
                <div className="flex flex-col">
                    <Typography variant="h6" sx={{ color: (theme) => theme.palette.text.primary }}>
                        {modalTitle}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: (theme) => theme.palette.text.secondary,
                            fontSize: '14px',
                            lineHeight: '20px'
                        }}
                    >
                        {modalDescription}
                    </Typography>
                    <FormControl component="fieldset" sx={{ mt: 2 }}>
                        <Typography variant="body1" fontWeight={600} gutterBottom sx={{
                            color: (theme) => theme.palette.text.secondary,
                            fontSize: '14px',
                            lineHeight: '20px'
                        }}>
                            {formatLabel}
                        </Typography>
                        <RadioGroup
                            aria-label="format"
                            name="format"
                            value={selectedFormat}
                            onChange={handleFormatChange}
                            row
                        >
                            <FormControlLabel
                                value="excel"
                                control={<Radio />}
                                label={formatExcelLabel}
                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        color: '#5547DD',
                                        fontWeight: '700',
                                    },
                                }}
                            />
                            <FormControlLabel
                                value="csv"
                                control={<Radio />}
                                label={formatCsvLabel}
                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        color: '#5547DD',
                                        fontWeight: '700',
                                    },
                                }}
                            />
                            <FormControlLabel
                                value="pdf"
                                control={<Radio />}
                                label={formatPdfLabel}
                                sx={{
                                    '& .MuiFormControlLabel-label': {
                                        color: '#5547DD',
                                        fontWeight: '700',
                                    },
                                }}
                            />
                        </RadioGroup>
                    </FormControl>
                </div>
                <div className="flex gap-2 justify-between mt-8">

                    <CustomIconButton text="Cancel"
                        background="transparent" outline={true} padding="0px"
                        variant="outlined"
                        onClick={handleDownloadModalClose}
                        isDisabled={downloadLoading}
                    />

                    <Button
                        text={downloadLoading ? 'Downloading...' : downloadButtonText}
                        onClick={handleDownload}
                        fullWidth={false}
                        startIcon={<FileDownloadOutlinedIcon />}
                        disabled={downloadLoading}
                    />
                </div>
            </Box>
        </Modal>
    );
}

export default DownloadData;
